import React from 'react';
import { products } from '../../data/products';
import Hero from '../../components/Hero';
import ProductCard from '../../components/ProductCard';

const Intercoms = () => {
  const intercoms = products.filter(product =>
    product.name.toLowerCase().includes('interfon') ||
    product.name.toLowerCase().includes('receptor')
  );

  return (
    <>
      <Hero
        title="Interfoane și Receptoare"
        subtitle="Sisteme moderne de interfonie pentru siguranța și confortul tău"
        backgroundImageUrl="/img/hero-cat-intercoms.jpg"
      />
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {intercoms.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Intercoms;
